import { useCallback, useEffect, useState } from 'react';

import { toast } from 'sonner';
import Honeybadger from '@honeybadger-io/js';

import { deserializer } from '../../../../shared/utils/deserializer';
import { usePagination } from '../../../shared/hooks';
import { fetchClients as apiFetchClients } from '../services/clientService';
import useClientFilters from './useClientFilters';

const useClientData = (searchQuery) => {
  const [clients, setClients] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const { activeFilters } = useClientFilters();
  const { handlePageChange, pagination, updatePagination } = usePagination();

  const fetchClients = useCallback(async () => {
    setIsLoading(true);

    try {
      const response = await apiFetchClients({
        activeFilters,
        clientName: searchQuery,
        page: pagination.currentPage,
        perPage: pagination.perPage,
      });

      const clients = await deserializer.deserialize(response);

      setClients(clients);
      updatePagination(response.meta.pagination);
    } catch (error) {
      toast.error(error.message);
      Honeybadger.notify(error);
    } finally {
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeFilters, pagination.currentPage, pagination.perPage, searchQuery]);

  useEffect(() => {
    fetchClients();
  }, [fetchClients]);

  return {
    clients,
    fetchClients,
    handlePageChange,
    isLoading,
    pagination,
  };
};

export default useClientData;
